/** @clearscore/helpers.cache v1.18.12: 2023-3-8 15:45 (assemble v5.5.3) **/
import canUseDom from '@clearscore/helpers.can-use-dom';
var CACHE_NAME = '__cs__';
var objGlobal = canUseDom() ? window : {};
objGlobal[CACHE_NAME] = objGlobal[CACHE_NAME] || {};
objGlobal[CACHE_NAME].verticals = objGlobal[CACHE_NAME].verticals || {};
objGlobal[CACHE_NAME].envs = objGlobal[CACHE_NAME].envs || {};
var cache = objGlobal[CACHE_NAME];
function loadRoutes() {
  return cache.routes || [];
}
function hasComponent(name) {
  var vertical = cache.verticals[name];
  return !!vertical;
}
function loadComponent(name) {
  var vertical = cache.verticals[name];
  return vertical ? vertical.Component : undefined;
}
function getEntry(key) {
  if (cache && cache[key]) {
    return cache[key];
  }
  return null;
}
function setEntry(key, value) {
  cache[key] = value;
  return getEntry(key);
}
export { cache, getEntry, hasComponent, loadComponent, loadRoutes, setEntry };